import { Navigate, useLocation } from "react-router-dom";
import {
  getFinanceUrl,
  getSettingsUrl,
  getSetupUrl,
  getScoringUrl,
} from "../../utility/adminNavigation";
import { useTournamentSlug } from "../../context/TournamentRouteContext";
import { tournamentPath } from "../../utility/tournamentUrls";

export function RedirectAdmin() {
  const tournamentSlug = useTournamentSlug();
  const { hash } = useLocation();
  const tab = hash.replace("#", "");

  if (tab === "financial") {
    return <Navigate to={getFinanceUrl(tournamentSlug, "added-money")} replace />;
  }
  if (tab === "settings") {
    return <Navigate to={getSettingsUrl(tournamentSlug)} replace />;
  }
  return <Navigate to={getSetupUrl(tournamentSlug)} replace />;
}

export function RedirectPayoutTable() {
  const tournamentSlug = useTournamentSlug();
  return (
    <Navigate to={getFinanceUrl(tournamentSlug, "payout-table")} replace />
  );
}

export function RedirectPayoutDashboard() {
  const tournamentSlug = useTournamentSlug();
  return <Navigate to={getFinanceUrl(tournamentSlug, "payouts")} replace />;
}

export function RedirectQrCodes() {
  const tournamentSlug = useTournamentSlug();
  return <Navigate to={`${getSettingsUrl(tournamentSlug)}#settings-qr`} replace />;
}

export function RedirectPrizes() {
  const tournamentSlug = useTournamentSlug();
  return <Navigate to={getFinanceUrl(tournamentSlug, "prizes")} replace />;
}

export function RedirectFinanceIndex() {
  const tournamentSlug = useTournamentSlug();
  return <Navigate to={getFinanceUrl(tournamentSlug, "payouts")} replace />;
}

export function RedirectScoringIndex() {
  const tournamentSlug = useTournamentSlug();
  const { search } = useLocation();
  return (
    <Navigate to={`${getScoringUrl(tournamentSlug, "scores")}${search}`} replace />
  );
}

export function RedirectResults() {
  const tournamentSlug = useTournamentSlug();
  const { search } = useLocation();
  return (
    <Navigate
      to={`${tournamentPath(tournamentSlug, "/standings")}${search}`}
      replace
    />
  );
}
